import { createContext } from 'react';

export const RowContext = createContext();

export default RowContext;
